'use client';

import { useState } from 'react';

import { Binoculars } from '@depop/web-thrift-ui/Illustrations/Binoculars';
import { Caption } from '@depop/web-thrift-ui/Typography';
import { useResponsive } from '@depop/web-thrift-ui/useResponsive';
import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';
import { useSavedSearchExperiment } from './useSavedSearchExperiment';

import { ButtonExperiment } from '@/components/ButtonExperiment';
import { SavedSearchUpsellModal } from '@/components/SavedSearchUpsellModal';
import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { useCurrentRoute } from '@/modules/activityTracker/useCurrentRoute';
import { useSearchInput } from '@/modules/search/useSearchInput';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function SavedSearchBanner() {
  const [isOpen, setIsOpen] = useState(false);
  const t = useTranslations('search');
  const { searchInput } = useSearchInput();
  const showBanner = useSavedSearchExperiment(Boolean(searchInput.trim()));
  const [, user] = useCurrentUser();
  const { sendActivityTrackerEvent } = useActivityTracker({ userId: user?.id });
  const page = useCurrentRoute();
  const urlPath = usePathname();
  const { isMinLarge } = useResponsive();

  if (!showBanner) {
    return null;
  }

  function handleClick() {
    sendActivityTrackerEvent(ActivityTrackerEventType.SAVED_SEARCH_MODAL_VIEW, {
      page,
      urlPath,
      schemaVersion: '1.0',
    });
    setIsOpen(true);
  }

  return (
    <>
      <div className={styles.banner}>
        <Binoculars size="xSmall" />
        <div className={styles.text}>
          <Caption variant="lg-bold" colour="base" as="span">
            {t('SavedSearch.Banner.Title')}
          </Caption>
          <Caption colour="base" as="span">
            {t('SavedSearch.Banner.Body')}
          </Caption>
        </div>
        <div className={styles.cta}>
          <ButtonExperiment
            type="button"
            size="small"
            onClick={handleClick}
            aria-label={t('SavedSearch.Banner.Title')}
            aria-haspopup="dialog"
          >
            {t('SavedSearch.Banner.Cta')}
          </ButtonExperiment>
        </div>
      </div>
      <SavedSearchUpsellModal
        isOpen={isOpen}
        setOpen={setIsOpen}
        isSheet={!isMinLarge}
      />
    </>
  );
}
